import { useState, useEffect, useContext } from 'react'
import { trackEvent } from 'analytics/trackFunctions'

// api
import { sendOTP } from 'api/OTP'

// context + store
import { MeContext } from 'contexts/me'

// utils + constants
import { getCodeToPaste } from 'utils'
import { useDebouncedInput } from 'hooks/useDebouncedInput'
import handleNotification from 'utils/toast/handleNotification'
import useCountdown from 'hooks/useCountdown'

// assets
import SmsIcon from 'assets/images/SMSenviado.svg'
import ErrorCircle from 'assets/images/error-circle.png'
import { CheckCircle, Refresh, Smartphone } from 'assets/icons'

// components
import SingleInput from './SingleInput'
import Table from './table'
import Tag from './Tag'
import TextButton from './textButton'

const OTPValidation = ({
  confirmAction,
  inputValue,
  setInputValue,
  inputStatus,
  isRequesting
}) => {
  const [counter, setCounter] = useState(59)
  const [loading, setLoading] = useState(false)

  const { me } = useContext(MeContext)
  const debouncedValue = useDebouncedInput(inputValue.join(''), 500)
  const timeLeft = useCountdown(counter, setCounter)

  const lastDigitsPhone = me?.profile.phone.slice(-2)

  const { errorToast, successToast } = handleNotification()

  const redirectWhatsApp = () => {
    window.open(
      `https://api.whatsapp.com/send?phone=5491152390637&text=`,
      '_blank'
    )
  }

  const resendCode = async () => {
    setLoading(true)
    setCounter(59)

    sendOTP()
      .then(({ success }) => {
        if (!success) {
          errorToast('Ocurrió un error, espera e intentá de nuevo')
        } else {
          successToast('Reenviamos el código')
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if (debouncedValue && debouncedValue.length === 6) {
      confirmAction()
    }
  }, [debouncedValue])

  useEffect(() => {
    if (inputStatus === 'success') {
      setCounter(5)
    }
  }, [inputStatus])

  return (
    <>
      <img className='h-12 w-12 my-4' src={SmsIcon} alt='' />
      <h2 className='text-black font-bold text-center py-1 text-xl mb-2'>
        Ingresá el código de seguridad
      </h2>
      <p className='text-black text-center font-medium'>
        Te enviamos un código de 6 dígitos por <br /> SMS al{' '}
        <span className='font-bold'>
          celular que termina en {lastDigitsPhone}.
        </span>
      </p>
      <Tag className='!text-black bg-blue-100 text-2xs p-2 font-medium my-4'>
        <span className='font-bold'>Tip:</span> Te sugerimos revisar tu carpeta
        de spam
      </Tag>

      {!!counter && inputStatus !== 'success' && (
        <p className='mb-3 text-xs text-black'>
          Podrás reenviarlo dentro de{' '}
          <span className='font-bold'>{timeLeft}</span> segundos{' '}
        </p>
      )}

      <form className='flex flex-col items-center'>
        <SingleInput
          OTPInput={inputValue}
          setOTPInput={setInputValue}
          classNames='w-full items-center flex justify-center gap-2'
          name='code'
          disabled={isRequesting}
          type='number'
          status={inputStatus}
        />

        {/* {statusInput !== 'success' && (
          <TextButton
            className='text-xs mb-4'
            handleFunction={() => {
              navigator.clipboard.readText().then((text) => {
                setOTPInput(getCodeToPaste(text))
              })
            }}
          >
            Pegar código
          </TextButton>
        )} */}

        {inputStatus === 'error' && (
          <div className='text-2xs flex gap-1 justify-center'>
            <img className='w-4 h-4' src={ErrorCircle} alt='' />
            <p>No es correcto, escribí de nuevo el código</p>
          </div>
        )}

        {inputStatus === 'success' && (
          <>
            <div className='text-2xs flex gap-1 justify-center'>
              <CheckCircle className='w-4 h-4' />
              <p>¡Verificado correctamente!</p>
            </div>
            <div className='text-xs text-gray-900 mt-6'>
              <p>Te redireccionaremos en</p>
              <p className='text-center'>
                <span className='font-bold'> {timeLeft}</span>
              </p>
            </div>
          </>
        )}

        {!counter && inputStatus !== 'success' && (
          <>
            <p className='text-xs font-bold text-center text-black font-sans my-3'>
              ¿No lo recibiste?
            </p>

            <Table className='py-2 border border-gray-500'>
              <div className='flex items-center gap-2'>
                <Refresh />
                <TextButton
                  className='text-xs'
                  handleFunction={() => {
                    trackEvent({
                      eventName: 'bille_adelantos_botón_reenviar'
                    })
                    resendCode()
                  }}
                  isDisabled={loading}
                  hasIconRight
                >
                  Reenviar código
                </TextButton>
              </div>
              <hr className='my-3' />
              <div className='flex items-center gap-2'>
                <Smartphone />
                <TextButton
                  className='text-xs'
                  handleFunction={() => {
                    trackEvent({
                      eventName: 'bille_adelantos_botón_cambiar_celular'
                    })
                    redirectWhatsApp()
                  }}
                  hasIconRight
                >
                  Quiero cambiar mi celular
                </TextButton>
              </div>
            </Table>
          </>
        )}
      </form>
    </>
  )
}

export default OTPValidation
